import styled from 'styled-components';
import { SectionParent, BlueButton } from '../../components/StyledComponents';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EnhancedBadge from '../../assets/v2/Hardware/enhanced-curve.svg';
import ValidatedBadge from '../../assets/v2/DigitalSignage/ValidatedBadge.svg';
import LikedWish from '../../assets/v2/Hardware/LikedWish.svg';
import Heart from '../../assets/v2/Hardware/heart-plain.svg';
import { Title } from '../../components/Esper/HomePage/HomepageSectionOne';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import RequestDemoForm from './ModalForm';
import { navigate } from '@reach/router';
import HeartFilled from '../../assets/v2/Hardware/HeartFilled.svg';
const ImgItem = styled(LazyLoadImage)`
  max-width: 80%;
  justify-self: center;
  margin-top: 3.5rem;
`;

export const HeroPointsSection = styled.div`
  margin-top: 2rem;
  margin-left: 3rem;
  border: solid 1px #979797;
  padding: 1rem;
  text-align: center;
  span:first-child {
    margin-left: 0rem !important;
  }
  span {
    margin-left: 1rem;
  }
  @media (max-width: 768px) {
    display: none;
    width: 80%;
  }
`;
const BlueButtonNew = styled(BlueButton)`
  margin-top: 2rem;
  margin-left: 3rem;
  width: 40%;
  @media (max-width: 800px) {
    justify-self: center;
    margin-top: 3rem;
    width: 60%;
    margin-left: 0rem;
  }
`;
const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  padding-top: 3rem !important;
  padding-bottom: 5rem;
  background-size: contain;
  background-color: #ffffff;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 3rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 1rem !important;
  }
  width: 100%;
  display: grid;
`;

export const HardwareSectionItemContainer = styled.div`
  grid-template-columns: repeat(15, 1fr);
  padding-left: 5rem;
  display: grid;
  align-items: start;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;

const SectionOneTitle = styled(Title)`
  line-height: 1.15;
  color: #000f16;
  margin-left: 3rem;
  margin-top: 0rem;
  @media (max-width: 768px) {
    text-align: center;
    margin-top: 1rem;
    padding: 0 3rem;
    margin-left: 0;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding: 0 1rem;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0;
  }
  @media (max-width: 320px) {
    width: 100%;
  }
`;

const GridRight = styled.div`
  grid-column: span 8;
  /* padding-right: 3rem;
  padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
    padding-right: 0rem;
  }
  @media (max-width: 768px) {
    grid-column: span 15;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridLeft = styled.div`
  grid-column: span 5;
  display: grid;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 14;
    padding-left: 0;
    justify-self: center;
  }
  @media (max-width: 520px) {
    width: 80%;
  }
`;
const GridMiddle = styled.img`
  display: grid;
  justify-items: center;
  align-items: start;
  grid-column: span 1;
  margin-top: 2.8rem;
  @media (max-width: 768px) {
    margin-right: 3rem;
  }
`;
export const HardwareHeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: justify;
  line-height: 1.64;
  letter-spacing: normal;
  color: #000f16;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding: 0 1rem;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
    font-size: 14px;
  }
  @media (max-width: 520px) {
    padding: 0 1rem;
  }
  @media (max-width: 350px) {
    padding: 1rem;
    padding-right: 0rem;
    width: 95%;
  }
`;
export const HardwareSolutionsImageContainerImg = styled(LazyLoadImage)`
  animation: fadein 1s;
  /* width: 100%; */
  height: 5rem;
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @media (max-width: 1100px) {
    height: 5rem;
  }
`;

export const HardwareSolutionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 3rem;
  padding: 3rem;
  justify-content: center;
  overflow: auto;
  width: fit-content;
  max-height: 15rem;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 350px) {
    grid-gap: 1rem;
    padding: 2rem;
  }
`;
export const HardwareSolutionContainerItemText = styled.div`
  /* text-align: center; */
  margin-top: 5px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000f16;
  padding-left: 0 !important;
`;

export const HardwareSolutionContainerItem = styled.div`
  text-align: center !important;
  @media (max-width: 520px) {
    justify-self: center;
    width: 100%;
  }
`;
export const HeroPoint = styled.span`
  grid-column: span 1;
  color: #000f16;
  font-weight: bold;
  text-align: center;
`;
const HeaderSection = styled.div`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;
const BannerContainer = styled(LazyLoadImage)`
  width: 125px;
  margin-left: 2rem;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-left: 0;
    justify-self: center;
    padding-bottom: 0;
  }
`;

const TopSection = styled.div`
  padding: 2rem;
  padding-top: 3rem;
  position: relative;
  border-bottom: solid 1px #e8e8e8;
  border-top: solid 1px #e8e8e8;
  margin-top: 6rem !important;
  @media (max-width: 520px) {
    display: grid;
    justify-items: center;
    padding-bottom: 4rem;
    /* border-top: none; */
    margin-top: 3rem;
  }
`;
const BreadCrumbSection = styled.div`
  position: absolute;
  left: 5rem;
  top: 2rem;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #7f8495;
  padding: 0 2rem;
  @media (max-width: 650px) {
    left: unset;
    top: 4rem;
  }
`;

const HeartSection = styled.div`
  position: absolute;
  right: 10rem;
  display: grid;
  bottom: 1rem;
  @media (max-width: 768px) {
    right: 7rem;
  }
  @media (max-width: 650px) {
    display: none;
  }
`;

const HeartSectionMobile = styled(HeartSection)`
  display: none;
  @media (max-width: 650px) {
    display: grid;
    right: 3rem;
    top: 10px;
    height: 1rem;
  }
`;
const WishNumber = styled.div`
  padding: 3px;
  font-size: 14px;
  box-shadow: 0 1px 4px 0 #8392aa;
  border-radius: 15px;
  width: 22px;
  height: 22px;
  margin-left: 1rem;
  text-align: center;
  display: grid;
  align-content: center;
  background: #ff8686;
`;
export default class SectionOne extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      wishedItem: false,
      wishArray: [],
      isOpen: false,
    };
  }

  componentDidMount() {
    let storedList = localStorage.getItem('wishlist');
    storedList = storedList === null ? [] : JSON.parse(storedList);
    this.setState({ wishArray: storedList }, () => this.checkWish());
    this.getWishList();
  }
  executeScroll = () => {
    const scroll = document.getElementById('demo-form-hardware');
    if (scroll) {
      scroll.scrollIntoView();
    }
  };

  handleWishList = (name: any) => {
    if (this.state.wishArray.some((item1: any) => item1 === name)) {
      const newlist = this.state.wishArray.filter((x: any) => x !== name);
      this.setState({ wishArray: [...newlist], wishedItem: false }, () => {
        localStorage.setItem('wishlist', JSON.stringify(this.state.wishArray));
        this.getWishList();
      });
    } else {
      this.setState(
        { wishArray: [...this.state.wishArray, name], wishedItem: true },
        () => {
          localStorage.setItem(
            'wishlist',
            JSON.stringify(this.state.wishArray)
          );
          this.getWishList();
        }
      );
    }
  };

  getWishList = () => {
    let storedList = localStorage.getItem('wishlist');
    storedList = storedList === null ? [] : JSON.parse(storedList);
    this.setState({
      wishArray: storedList,
    });
  };
  checkWish = () => {
    if (
      this.state.wishArray.some(
        (item1: any) => item1 === this.props.hardware.id
      )
    ) {
      this.setState({ wishedItem: true }, () => this.getWishList());
    }
  };

  open = () => this.setState({ isOpen: true });

  close = () => this.setState({ isOpen: false });
  render() {
    return (
      <div>
        <ModalTransition>
          {this.state.isOpen && (
            <Modal onClose={this.close}>
              <RequestDemoForm close={this.close} />
            </Modal>
          )}
        </ModalTransition>
        {/* <Wrapper> */}
        <TopSection>
          <HeartSectionMobile
            onClick={() => navigate('/wishlist')}
            style={{ cursor: 'pointer' }}
          >
            <WishNumber>{this.state.wishArray.length}</WishNumber>
            <img src={HeartFilled} />
          </HeartSectionMobile>
          <BreadCrumbSection>
            <span
              onClick={() => navigate('/hardware')}
              style={{ cursor: 'pointer' }}
            >
              Commercial Android /
            </span>
            <span
              onClick={() =>
                navigate(
                  this.props.hardware.data.isEAA
                    ? '/hardware/product-list/esper-enhanced'
                    : '/hardware/product-list/esper-validated'
                )
              }
              style={{ cursor: 'pointer' }}
            >
              {this.props.hardware.data.isEAA
                ? ' Esper Enhanced Android Devices '
                : ' Esper Validated Android Devices '}
              /
            </span>
            <span style={{ fontWeight: 'bold' }}>
              {' '}
              {this.props.hardware.data?.Name}
            </span>
          </BreadCrumbSection>
          <HeartSection
            onClick={() => navigate('/wishlist')}
            style={{ cursor: 'pointer' }}
          >
            <WishNumber>{this.state.wishArray.length}</WishNumber>
            <img src={HeartFilled} />
          </HeartSection>
        </TopSection>

        <Section>
          <HardwareSectionItemContainer>
            <GridLeft>
              <ImgItem
                alt={this.props.hardware.data?.Title_Tag}
                src={this.props.hardware.data.Image?.[0]?.url}
              />
            </GridLeft>
            {this.state.wishedItem === true ? (
              <GridMiddle
                onClick={() => this.handleWishList(this.props.hardware.id)}
                src={LikedWish}
                style={{ height: '60px', cursor: 'pointer' }}
              />
            ) : (
              <GridMiddle
                onClick={() => this.handleWishList(this.props.hardware.id)}
                src={Heart}
                style={{ height: '60px', cursor: 'pointer' }}
              />
            )}
            <GridRight>
              <HeaderSection>
                <SectionOneTitle>
                  {this.props.hardware.data?.Name}
                </SectionOneTitle>
                <BannerContainer
                  src={
                    this.props.hardware.data.isEAA
                      ? EnhancedBadge
                      : ValidatedBadge
                  }
                />
              </HeaderSection>
              <HardwareHeroSubTitle style={{ paddingTop: '1rem' }}>
                {this.props.hardware.data.Description}
              </HardwareHeroSubTitle>

              {/* <HeroPointsSection>
                {this.props.hardware.data.tags.map((item: any) => (
                  <HeroPoint key={item}>{item}</HeroPoint>
                ))}
              </HeroPointsSection> */}
              <HardwareSolutionsContainer
                style={
                  this.props.hardware?.data?.Industries?.length > 5
                    ? { marginTop: '2rem' }
                    : {}
                }
              >
                {this.props.hardware.data.Industries?.map(
                  (item: any, key: number) => (
                    <HardwareSolutionContainerItem
                      key={item.data.Photo?.[0]?.url + key}
                    >
                      <HardwareSolutionsImageContainerImg
                        src={item.data.Photo?.[0]?.url}
                      />
                      <HardwareSolutionContainerItemText
                        style={{ paddingLeft: '2.5rem' }}
                      >
                        {item.data.Name}
                      </HardwareSolutionContainerItemText>
                    </HardwareSolutionContainerItem>
                  )
                )}
              </HardwareSolutionsContainer>
              <BlueButtonNew onClick={() => this.executeScroll()}>
                Get pricing
              </BlueButtonNew>
            </GridRight>
          </HardwareSectionItemContainer>
        </Section>
        {/* </Wrapper> */}
      </div>
    );
  }
}
